export const agentSpecResources = {
  fr: {
    eyebrow: "Agent Studio",
    title: "Agent Spec",
    calistoNavigation: "Calisto",
    description:
      "Contrôlez le desired state de cet Agent avec un plan immuable et la gouvernance adaptée à l’environnement.",
    selectContextTitle: "Sélection requise",
    selectOrganization:
      "Sélectionnez une organisation pour charger l’Agent Spec.",
    selectAgent: "Sélectionnez un Agent pour charger son Agent Spec.",
    loading: "Chargement de l’Agent Spec…",
    refresh: "Actualiser",
    retry: "Réessayer",
    errorTitle: "Agent Spec indisponible",
    missingTitle: "Aucune Agent Spec",
    missingDescription:
      "Initialisez un draft vide. Cette action ne crée aucune ressource runtime.",
    initAction: "Initialiser Agent Spec",
    initPending: "Initialisation…",
    overviewTitle: "Cet Agent",
    overviewDescription:
      "Ce qui est publié : Workflows et MiniApps. Le détail d’un fichier se voit en l’ouvrant.",
    overviewEmptyWorkflows: "Aucun Workflow.",
    overviewEmptyMiniapps: "Aucune MiniApp.",
    studioPublished: "Publié",
    identityTitle: "Titre dans la spec",
    agentMenu: "Actions de l’Agent",
    renameAgent: "Renommer",
    renameAgentTitle: "Renommer l’Agent",
    renameAgentDescription: "Ce nom apparaît dans l’arbre Studio.",
    renameAgentNameLabel: "Nom",
    renameAgentConfirm: "Enregistrer",
    renameAgentSuccess: "Agent renommé.",
    renameAgentError: "Impossible de renommer cet Agent.",
    deleteAgent: "Supprimer",
    deleteAgentTitle: "Supprimer l’Agent « {{name}} » ?",
    deleteAgentDescription:
      "Retire définitivement cet Agent, ses Workflows et ses fils Studio. Cette action est irréversible.",
    deleteAgentConfirm: "Supprimer",
    deleteAgentSuccess: "Agent supprimé.",
    deleteAgentError: "Impossible de supprimer cet Agent.",
    importExportAgent: "Import / Export",
    status: "Statut",
    resourceVersion: "Version de ressource",
    specHash: "Spec hash",
    contract: "Contrat",
    lastUpdate: "Dernière actualisation",
    warningCount: "{{count}} avertissement(s)",
    currentPlanTitle: "Plan courant",
    currentPlanDescription:
      "Le plan à traiter maintenant : progression, prochaine action, puis historique des autres plans.",
    currentPlanEmpty:
      "Aucun plan sélectionné. Préparez-en un depuis le thread Studio, ou ouvrez un plan dans l’historique.",
    otherPlansTitle: "Autres plans",
    otherPlansDescription:
      "Historique des plans préparés par MauriceCLI, MCP ou l’OS. Un clic remplace le plan courant.",
    otherPlansEmpty: "Aucun autre plan — le plan courant est le seul disponible.",
    persistedPlansTitle: "Plans persistés à examiner",
    persistedPlansDescription:
      "Plans préparés par MauriceCLI, MCP ou l’OS. Chargez le détail exact avant toute approbation humaine.",
    persistedPlansLoading: "Chargement des plans persistés…",
    persistedPlansError: "Impossible de charger les plans persistés.",
    persistedPlansEmpty: "Aucun plan préparé, approuvé ou appliqué récemment.",
    refreshPlans: "Actualiser les plans",
    planStatusPrepared: "À approuver",
    planStatusApproved: "Approuvé",
    planStatusApplying: "Application en cours",
    planStatusApplied: "Appliqué",
    planStatusFailed: "Échec",
    planStatusExpired: "Expiré",
    planStatusSuperseded: "Remplacé",
    gitCommit: "Commit Git",
    expiresAt: "Expiration",
    exactArtifactTitle: "Artefact exécutable exact",
    exactArtifactDescription:
      "Cet artefact persistant est celui que l’approbation engage et qu’apply exécutera sans recompilation.",
    railTitle: "Plan courant",
    railDescription:
      "En development : préparez puis mettez en œuvre depuis le thread Studio. Staging/production exigent une approbation humaine.",
    railHintPull: "Chargez d’abord le desired state (Pull).",
    railHintPrepare:
      "Étape suivante : Préparer le plan depuis le thread Studio courant (check + plan ; en development l’application peut enchaîner automatiquement).",
    railHintApprove:
      "Étape suivante : Approuver le plan (approbation humaine requise sur cet environnement).",
    railHintCloseout:
      "Étape suivante : Mettre en œuvre (apply → verify, avec réparation auto si besoin).",
    railHintApplyPersisted:
      "Étape suivante : Appliquer ce plan persisté. « Mettre en œuvre » ne s’applique qu’au plan scellé du thread Studio.",
    railHintSuperseded:
      "Ce plan a été remplacé ou a expiré. Un plan plus récent a été sélectionné, ou préparez-en un nouveau depuis le thread Studio.",
    railHintVerify: "Étape suivante : Vérifier le résultat runtime.",
    railHintIdle: "Aucune action urgente — ce plan est déjà traité ou hors fenêtre.",
    railHintSelectOrCalisto:
      "Ouvrez Calisto pour préparer un plan depuis un thread Studio, ou choisissez un plan dans l’historique.",
    closeoutRequiresSealedRevision:
      "Mettre en œuvre exige un plan préparé depuis le thread Studio (révision scellée). Pour ce plan, utilisez « Appliquer le plan ».",
    closeoutRequiresPlan:
      "Aucun plan n’est lié à la révision Studio. Préparez d’abord le plan depuis le thread.",
    stepPull: "Pull",
    stepPullDescription: "Desired state V2 chargé depuis la source canonique.",
    stepCheck: "Check",
    stepCheckDescription: "Contrats, capacités et références validés.",
    stepPlan: "Plan",
    stepPlanDescription:
      "Diff et préconditions compilés dans un artefact immuable.",
    stepApproval: "Approbation",
    stepApprovalDescription:
      "Autorisation automatique par policy ou approbation humaine selon l’environnement.",
    stepApply: "Apply",
    stepApplyDescription: "Application idempotente de l’artefact approuvé.",
    stepVerification: "Vérification",
    stepVerificationDescription:
      "Desired state, runtime et provenance comparés.",
    stateReady: "Prêt",
    stateWaiting: "En attente",
    stateRunning: "En cours",
    stateComplete: "Terminé",
    stateFailed: "Échec",
    checkAction: "Vérifier la spec",
    checkPending: "Vérification…",
    planAction: "Préparer pour validation",
    planPending: "Préparation…",
    approvalAction: "Approuver le plan",
    applyAction: "Appliquer le plan",
    applyPending: "Application…",
    verifyAction: "Vérifier le résultat",
    verifyPending: "Vérification runtime…",
    closeoutAction: "Mettre en œuvre",
    closeoutPending: "Mise en œuvre…",
    closeoutDescription:
      "Applique le plan approuvé, vérifie le runtime, puis répare automatiquement en cas d’échec.",
    studioPrepareAutoAction: "Préparation automatique…",
    studioPrepareAutoPending: "Préparation et mise en œuvre…",
    studioPrepareAutoStarted: "Plan préparé — closeout en cours ou terminé.",
    studioCloseoutStayInChat:
      "Draft appliqué. Pour continuer à modifier, commencez une nouvelle révision puis décrivez le changement.",
    studioNewRevisionReady:
      "Nouveau draft prêt — décrivez la prochaine modification à Calisto.",
    studioNewRevisionHint:
      "Ouvre un nouveau draft éditable dans ce fil. Décrivez ensuite le changement dans le champ ci-dessous.",
    studioContinueWithCalisto: "Continuer dans Studio",
    openInCalisto: "Ouvrir dans Studio",
    studioViewAppliedPlan: "Voir ce qui a été publié",
    closeoutStatusIdle: "Aucun closeout en cours",
    closeoutStatusAwaitingApproval: "En attente d’approbation après réparation",
    closeoutStatusClosingOut: "Publication en cours",
    closeoutStatusSucceeded: "Publication réussie",
    closeoutStatusRepairing: "Nouvel essai automatique",
    closeoutStatusBlocked: "Publication interrompue",
    closeoutRepairCycles: "Essais automatiques : {{current}}/{{max}}",
    closeoutEvidence: "Détail technique : {{detail}}",
    closeoutTechnicalDetail: "Détail technique",
    closeoutBlockedOutOfScope:
      "Un autre changement a eu lieu en même temps sur cet Agent. Le Workflow est déjà disponible ; le contrôle n’a pas pu se terminer. Vous n’avez rien à réécrire.",
    closeoutBlockedHuman:
      "Le contrôle automatique n’a pas pu se terminer. Vous n’avez rien à réécrire.",
    studioPreparePlanPublish: "Publier le brouillon",
    studioPrepareHintPublish:
      "Publie tout de suite sur cet Agent. Vous pourrez encore modifier ensuite.",
    studioPrepareHintReview:
      "Prépare une proposition. Un humain devra l’approuver avant publication.",
    studioComposerExampleAdd: "Ajouter un workflow de test qui renvoie une note",
    studioComposerExampleAdditive: "Ne rien modifier d’existant : seulement ajouter",
    studioOpenPublishedWorkflow: "Ouvrir {{name}}",
    studioJobStatusQueued: "StudioJob en file",
    studioJobStatusRunning: "StudioJob en cours",
    studioJobStatusSucceeded: "StudioJob réussi",
    studioJobStatusBlocked: "StudioJob bloqué",
    studioJobStatusCancelled: "StudioJob annulé",
    studioJobGoalLabel: "Goal : {{title}}",
    checkRequired: "Un check valide est requis avant de préparer le plan.",
    approvalRequired:
      "La policy de cet environnement exige une approbation humaine avant apply.",
    policyAuthorized: "Autorisé automatiquement par la policy serveur.",
    approvalDialogTitle: "Approbation humaine",
    approvalDialogDescription:
      "Confirmez le diff, le risque, l’environnement, le commit et le hash. Le serveur lie votre identité au plan exact.",
    approvalCommentLabel: "Commentaire facultatif",
    approvalCommentPlaceholder: "Contexte ou remarque pour l’audit…",
    approvalTextLabel: "Texte d’approbation",
    approvalTextPlaceholder: "J’approuve le plan {{hash}}",
    approvalHashHint: "Hash exact : {{hash}}",
    approvalCancel: "Annuler",
    approvalConfirm: "Enregistrer l’approbation",
    approvalPending: "Enregistrement…",
    approvalTextInvalid: "Le texte doit contenir le hash exact du plan.",
    failureTitle: "Échec d’application",
    failureRecovery:
      "Créez un nouveau plan avec maurice spec deploy après avoir corrigé la cause.",
    currentRuntimePlan: "État runtime courant issu du plan {{planId}}.",
    planTitle: "Plan immuable",
    planDescription: "Plan {{id}} — expiration {{expiresAt}}",
    noPlan: "Préparez un plan pour afficher le diff, le risque et les tests.",
    diffTitle: "Diff sémantique",
    diffEmpty: "Aucun changement sémantique.",
    diffAdded: "{{count}} ajout(s)",
    diffModified: "{{count}} modification(s)",
    diffRemoved: "{{count}} suppression(s)",
    riskTitle: "Risque",
    riskLow: "Faible",
    riskMedium: "Moyen",
    riskHigh: "Élevé",
    riskCritical: "Critique",
    blastRadiusTitle: "Blast radius",
    blastRadiusEmpty: "Aucun composant runtime touché.",
    testsTitle: "Politique de tests",
    testsMode: "Mode",
    testsEnvironment: "Environnement",
    testsBlocking: "Bloquant",
    testsPlan: "Test plan",
    present: "Présent",
    absent: "Absent",
    yes: "Oui",
    no: "Non",
    resourcesTitle: "Ownership des ressources",
    resourcesDescription:
      "Les Workflows et MiniApps inclus dans cette Agent Spec sont managed et ne sont jamais modifiables directement.",
    workflowsTitle: "Workflows",
    miniappsTitle: "MiniApps",
    plansNavigation: "Plans",
    executionsNavigation: "Exécutions",
    agentView: "Vue Agent",
    navGroup: "Agent Spec",
    agentOverview: "Vue d'ensemble",
    workflowLabel: "Workflow",
    miniappLabel: "MiniApp",
    resourceSummary: "Résumé",
    resourceGraph: "Graphe",
    resourceApiCall: "Appel API",
    resourcePreview: "Preview",
    synchronousWorkflowCall: "Appel synchrone",
    synchronousWorkflowCallDescription:
      "Attend la fin du Workflow et retourne directement son résultat.",
    asynchronousWorkflowCall: "Appel asynchrone",
    asynchronousWorkflowCallDescription:
      "Démarre le Workflow, retourne immédiatement un identifiant d’exécution, puis permet de suivre son état.",
    pollWorkflowExecution: "Suivre l’exécution",
    graphSelectNode: "Sélectionnez un nœud pour afficher sa configuration.",
    graphNodeDetails: "Détails du nœud",
    graphCloseNodeDetails: "Fermer les détails du nœud",
    graphNodeId: "Identifiant",
    graphNodeType: "Type",
    graphNodeConfiguration: "Configuration",
    selectResource: "Sélectionnez une ressource.",
    noResourceDescription: "Aucune description.",
    runtimeResourcesErrorTitle: "Ressources runtime indisponibles",
    runtimeResourcesErrorDescription:
      "La liste affichée peut être incomplète. Les Workflows et MiniApps runtime n’ont pas pu être chargés.",
    retryRuntimeResources: "Recharger les ressources runtime",
    workflowActions: "Actions",
    miniappEvents: "Événements",
    resourceOwnershipAndProvenance: "Ownership et provenance",
    managementMode: "Mode de gestion",
    ownerRevision: "Révision propriétaire",
    ownerAgentSpec: "Agent Spec propriétaire",
    contentHash: "Hash du contenu",
    inputSchema: "Schéma d’entrée",
    outputSchema: "Schéma de sortie",
    workflowForms: "Formulaires",
    miniappRenderer: "Renderer",
    miniappComponent: "Composant",
    stateSchema: "Schéma d’état",
    initialState: "État initial",
    eventMappings: "Mappings d’événements",
    copyApiRequest: "Copier la requête API",
    apiRequestCopied: "Requête API copiée.",
    apiAvailableAfterApply:
      "Cet appel sera disponible après l’application du draft.",
    createMiniappSession: "Créer une session MiniApp",
    miniappEventLabel: "Événement MiniApp",
    manageApiKeys: "Gérer les clés API",
    resourceState: {
      deployed: "Déployé",
      modified: "Modifié",
      new: "Nouveau",
      deleted: "Supprimé",
      outsideSpec: "Hors Agent Spec",
    },
    previewSandboxDescription:
      "Cette preview temporaire exécute le draft sur l’Agent courant (sandbox, development ou integration_test) sans créer de ressource runtime managed.",
    previewRuntimeDescription:
      "Cette preview lance une session runtime de la MiniApp déployée sur cet Agent, sans modifier le desired state.",
    previewRequiresSandboxTitle: "Preview indisponible sur cet Agent",
    previewRequiresSandboxBody:
      "L’Agent courant est en mode « {{profile}} ». La preview de draft est réservée aux Agents sandbox, development et integration_test. En staging/production, utilisez le cycle d’approbation, ou basculez vers un Agent de développement.",
    previewRequiresSandboxError:
      "La preview de draft n’est pas disponible sur cet Agent (mode « {{profile}} »). Elle est autorisée en sandbox, development et integration_test.",
    previewUnknownProfile: "inconnu",
    invalidPlanId:
      "Identifiant de plan invalide dans l’URL — paramètre ignoré. Sélectionnez un plan dans la liste.",
    previewCreateSandboxAgent: "Créer un Agent sandbox et y tester ce draft",
    previewSwitchAgentHint:
      "Ou ouvrez le sélecteur d’Agent en haut à gauche pour basculer vers un Agent sandbox existant.",
    previewCreateSandboxTitle: "Créer un Agent sandbox",
    previewCreateSandboxDescription:
      "Un nouvel Agent classé sandbox sera créé. Vous pourrez y initialiser un draft et lancer des previews sans toucher cet Agent.",
    previewCreateSandboxSeedDialogTitle:
      "Créer un Agent sandbox et y tester ce draft",
    previewCreateSandboxSeedDescription:
      "Confirmez pour créer l’Agent sandbox, y copier ce draft, ouvrir le chat et relancer la preview.",
    previewCreateSandboxSeedConfirm: "Confirmer",
    previewCreateSandboxSeedTitle: "Draft sandbox — {{name}}",
    previewCreateSandboxSeedSuccess:
      "Agent sandbox {{name}} prêt. Draft copié — preview en cours.",
    previewCreateSandboxContinueStarted: "Preview draft relancée sur le sandbox.",
    previewCreateSandboxContinueFailed:
      "Le draft a été copié, mais la preview n’a pas pu démarrer automatiquement.",
    previewCreateSandboxNameLabel: "Nom de l’Agent",
    previewCreateSandboxNamePlaceholder: "Assistant sandbox",
    previewCreateSandboxConfirm: "Créer et ouvrir",
    previewCreateSandboxSubmitting: "Création…",
    previewCreateSandboxSuccess: "Agent sandbox {{name}} créé.",
    previewCreateSandboxFailed: "Impossible de créer l’Agent sandbox.",
    previewCreateSandboxConflict:
      "Un Agent avec ce nom existe déjà. Choisissez un autre nom.",
    previewCreateSandboxNameRequired: "Le nom de l’Agent est requis.",
    previewConfirmTitle: "Exécuter cette preview ?",
    previewConfirmDescription:
      "Cette action exécute le draft dans une session sandbox temporaire sans modifier le runtime appliqué.",
    previewConfirmAction: "Exécuter la preview",
    runWorkflowPreview: "Exécuter la preview Workflow",
    runWorkflowPreviewBusy: "Preview Workflow en cours",
    previewExecutionStarted: "Exécution de preview démarrée",
    startMiniappPreview: "Ouvrir la preview MiniApp",
    studioChatPreviewTitle: "Preview {{kind}} — {{id}}",
    studioChatPreviewClose: "Fermer la preview",
    studioChatPreviewStarting: "Démarrage de la preview…",
    studioChatPreviewMissingDocument:
      "Document introuvable dans le draft courant.",
    studioChatPreviewOpenUIFallback:
      "Rendu OpenUI incomplet — bascule sur le rendu natif.",
    previewStateVersion: "État version {{version}}",
    executionsTitle: "Exécutions et observabilité",
    executionsDescription:
      "États, logs, traces, résultats, durées, usages et coûts des Workflows.",
    executionsEmpty: "Aucune exécution pour cet Agent.",
    refreshExecutions: "Actualiser les exécutions",
    executionDetails: "Détails de l’exécution",
    selectExecution: "Sélectionnez une exécution à examiner.",
    duration: "Durée",
    traceId: "Trace ID",
    llmCalls: "Appels LLM",
    tokens: "Tokens",
    estimatedCost: "Coût estimé",
    executionLogs: "Logs",
    executionLogsEmpty: "Aucun log.",
    executionResult: "Résultat",
    executionLoadError: "Impossible de charger cette exécution.",
    agentConfiguration: "Configuration de l’Agent",
    instructions: "Instructions",
    capabilities: "Capabilities",
    dependencies: "Dependencies",
    parameters: "Paramètres",
    secretReferences: "Références de secrets",
    policyReferences: "Policies",
    governance: "Gouvernance",
    exportBundle: "Exporter le bundle",
    noWorkflows: "Aucun Workflow déclaré.",
    noMiniapps: "Aucune MiniApp déclarée.",
    managed: "Managed",
    unmanaged: "Sandbox unmanaged",
    managedDescription:
      "Lecture seule — toute modification passe par un nouveau plan Agent Spec.",
    unmanagedDescription:
      "Mutation directe autorisée uniquement dans le sandbox explicitement unmanaged.",
    owner: "Owner",
    file: "Fichier",
    version: "Version",
    diagnosticsTitle: "Diagnostics",
    noDiagnostics: "Aucun diagnostic.",
    checkValid: "Agent Spec valide",
    checkInvalid: "Agent Spec invalide",
    verificationTitle: "Vérification finale",
    verificationVerified: "État vérifié",
    verificationDrifted: "Drift détecté",
    desiredStateMatch: "Desired state conforme",
    planApplied: "Plan appliqué",
    approvalApplied: "Approbation consommée",
    provenance: "Provenance",
    studioPanelTitle: "Studio",
    studioPanelDescription:
      "Ce fil partagé modifie uniquement le draft Agent Spec V2.",
    studioNewThreadTitle: "Nouveau fil Studio",
    studioNewThreadDescription:
      "Choisissez l’Agent hôte, une Application optionnelle et l’environnement.",
    studioNewThreadContextualDescription:
      "Ce fil utilise la portée de ce nœud.",
    studioHostAgentLabel: "Agent hôte",
    studioHostAgentPlaceholder: "Choisir un Agent hôte",
    studioHostRequired: "Choisir un Agent hôte",
    studioScopeApplicationLabel: "Application (portée)",
    studioScopeApplicationNone: "Cet Agent seulement",
    studioEnvironmentLabel: "Environnement",
    studioHostLabel: "Hôte",
    studioScopeLabel: "Portée",
    studioScopeThisAgent: "cet Agent",
    studioHostHint:
      "Ce fil est hébergé par {{host}}. Un plan d’architecture peut toucher d’autres Agents.",
    studioContinueInStudio: "Continuer dans Studio",
    studioContinueInStudioGoal: "Observer puis ajuster la surface de {{app}}",
    studioViewConversation: "Conversation",
    studioViewPlans: "Plans",
    studioViewTrajectory: "Trajectoire",
    studioSearchThread: "Rechercher dans ce fil",
    studioSearchPlaceholder: "Messages, plans, outils…",
    studioForkThread: "Bifurquer",
    studioForkPending: "Bifurcation…",
    studioForkSuccess: "Nouveau fil créé depuis cette révision",
    studioChipPlanReady: "Plan à approuver",
    studioChipApplying: "Application en cours…",
    studioChipApplied: "Appliqué",
    studioChipBlocked: "À corriger",
    studioBackToThread: "Retour au fil",
    studioThreadMore: "Autres actions du fil",
    studioThreadJournal: "Journal",
    studioNoPlansOnThread: "Aucun plan sur ce fil.",
    studioEventThreadCreated: "Fil créé",
    studioEventMessageCreated: "Message",
    studioEventTurnStarted: "Tour commencé",
    studioEventTurnCompleted: "Tour terminé",
    studioEventDraftChecked: "Draft vérifié",
    studioEventRevisionUpdated: "Révision mise à jour",
    studioEventToolStarted: "Outil lancé",
    studioEventToolCompleted: "Outil terminé",
    studioNewCycle: "Nouveau cycle",
    studioReplayPreview: "Rejouer (preview)",
    studioTrajectoryEmpty: "Aucun événement de trajectoire pour ce fil.",
    studioTrajectoryKindSystem: "Système",
    studioTrajectoryKindUser: "Utilisateur",
    studioTrajectoryKindContext: "Contexte",
    studioTrajectoryKindTool: "Outil",
    studioTrajectoryKindSubtool: "Sous-outil",
    studioTrajectoryKindDecision: "Décision",
    studioInspectorSummary: "Résumé",
    studioInspectorInput: "Entrée",
    studioInspectorResult: "Résultat",
    studioInspectorSchema: "Schéma",
    studioInspectorDuration: "Durée",
    studioPlanKindArchitecture: "Plan d’architecture",
    studioPlanKindAgentSpec: "Plan Agent Spec",
    studioPlanRisk: "Risque",
    studioPlanScope: "{{workflows}} Workflows · {{apps}} Applications",
    studioPlanEnvironment: "Environnement",
    compositionTitle: "Composition effective",
    compositionDescription:
      "Lecture seule : modèle résolu, provenance et surface runtime. Le catalogue LLM reste dans Plateforme.",
    compositionNoAgent: "Sélectionnez un Agent pour voir sa composition.",
    compositionLlm: "Modèle résolu",
    compositionProvenance: "Provenance",
    compositionDoctor: "Doctor",
    compositionModules: "Modules",
    compositionSkills: "Skills de session",
    compositionMcp: "MCP / sidecars",
    compositionGaps: "Écarts",
    compositionEmpty: "Aucune composition disponible pour cet Agent.",
    studioNoThread: "Aucun fil pour cet Agent.",
    studioNoThreadYet: "Aucun fil pour le moment.",
    studioThreadsTitle: "Fils Studio",
    studioThreadsLoading: "Chargement des fils…",
    studioThreadsMore: "Plus",
    studioThreadsLess: "Moins",
    studioSelectThreadHint:
      "Sélectionnez un fil dans la sidebar ou créez-en un nouveau.",
    studioCreateThread: "Nouveau fil",
    studioUntitledThread: "Fil",
    studioCreateThreadSuccess: "Nouveau fil créé",
    studioChiefOfStaffWelcomeTitle: "Bienvenue",
    studioCreatingThread: "Création…",
    studioFromGoalAction: "Depuis un goal",
    studioFromGoalTitle: "Démarrer depuis un goal",
    studioFromGoalDescription:
      "Crée un fil Studio avec un StudioJob closed_loop lié à ce goal.",
    studioFromGoalTitleLabel: "Titre du goal",
    studioFromGoalTitlePlaceholder: "Ex. Ajouter un workflow de veille",
    studioFromGoalDescriptionLabel: "Description (optionnel)",
    studioFromGoalDescriptionPlaceholder:
      "Critères de succès ou contexte utile pour Calisto…",
    studioFromGoalCancel: "Annuler",
    studioFromGoalConfirm: "Créer le StudioJob",
    studioFromGoalPending: "Création…",
    studioFromGoalSuccess: "StudioJob créé depuis le goal",
    studioThreadLabel: "Fil partagé",
    studioEmptyMessages: "Décrivez les changements à apporter à cet Agent.",
    studioArchitectureEmptyTitle: "Graphe organisation (observe)",
    studioArchitectureEmptyLoading: "Lecture du graphe…",
    studioArchitectureEmptyError: "Impossible de charger le graphe d’architecture.",
    studioArchitectureEmptyApps: "{{count}} Application(s)",
    studioArchitectureEmptyAgents: "{{count}} Agent(s)",
    studioArchitectureEmptyGaps: "{{count}} écart(s)",
    studioArchitecturePlanTitle: "Plan d’architecture",
    studioArchitecturePlanApprove: "Approuver le plan d’architecture",
    studioArchitecturePlanApproved: "Plan d’architecture approuvé",
    studioExecutionPlanTitle: "Plan d’exécution",
    studioExecutionPlanGoal: "Objectif",
    studioExecutionPlanPhases: "{{count}} phase(s)",
    studioExecutionPlanPhaseNodes: "{{count}} nœud(s)",
    studioExecutionPlanNodes: "{{count}} nœud(s) au total",
    studioExecutionPlanParallel: "{{count}} en parallèle au plus",
    studioExecutionPlanJobs: "{{count}} jobs au plus",
    studioExecutionPlanDurationHM: "{{hours}} h {{minutes}} min",
    studioExecutionPlanDurationH: "{{hours}} h",
    studioExecutionPlanDurationM: "{{minutes}} min",
    studioExecutionPlanDurationS: "{{seconds}} s",
    studioExecutionPlanCost: "Coût max. {{amount}}",
    studioExecutionPlanCostUnbounded: "Coût non borné",
    studioExecutionPlanTimeout: "Durée max. {{duration}}",
    studioExecutionPlanStatusValidated: "Proposé",
    studioExecutionPlanStatusRunning: "Lancé",
    studioExecutionPlanStatusBlocked: "Bloqué",
    studioExecutionPlanStatusCompleted: "Terminé",
    studioExecutionPlanStatusFailed: "Échoué",
    studioExecutionPlanStatusCancelled: "Annulé",
    studioExecutionPlanLaunch: "Lancer",
    studioExecutionPlanLaunching: "Lancement…",
    studioExecutionPlanModify: "Modifier",
    studioExecutionPlanModifyPrefix: "Modifie le plan : ",
    studioExecutionPlanFollowActivity: "Suivre dans Activité",
    studioExecutionPlanStale: "Ce plan a changé depuis sa proposition. Il vient d’être rechargé : relisez-le avant de le lancer.",
    studioExecutionPlanLaunchError: "Impossible de lancer le plan.",
    studioConnectIntegrationSuccess: "Connexion prête.",
    studioConnectIntegrationError: "Impossible de démarrer la connexion.",
    studioConnectIntegrationRetryPrompt: "Compte {{name}} connecté. Réessaie l’action.",
    studioConnectIntegrationCancelled: "Connexion annulée.",
    integrationRiskTitle: "Confirmer {{name}}",
    integrationRiskFallbackName: "Intégration",
    integrationRiskFallbackAction: "action",
    integrationRiskCredits: "{{count}} crédit(s)",
    integrationRiskApprove: "Autoriser une fois",
    integrationRiskApproved: "Autorisation enregistrée. Relancez l’action.",
    integrationRiskApproveError: "Impossible d’enregistrer l’autorisation.",
    integrationRiskApproveSuccess: "Autorisation enregistrée.",
    integrationRiskRetryPrompt:
      "Relance le même outil avec exactement les mêmes arguments métier. Autorisation accordée (authorization_id={{id}}). Passe authorization_id={{id}} en champ frère de l’appel d’outil (pas à l’intérieur des arguments métier).",
    connectIntegrationTitle: "Connecter {{name}}",
    connectIntegrationBody: "Autorisez votre compte pour que l’Agent puisse l’utiliser dans ce fil.",
    capabilityChooseTitle: "Choisir pour {{name}}",
    capabilityChooseBody: "Plusieurs options sont possibles. Choisissez celle à brancher.",
    capabilityChooseFallbackName: "cette capacité",
    capabilityBlockedTitle: "{{name}} indisponible",
    capabilityBlockedFallbackName: "Cette capacité",
    capabilityBlockedReason: {
      not_in_org_allowlist: "Ce connecteur n’est pas autorisé pour votre organisation.",
      insufficient_credits: "Crédits insuffisants pour activer ce connecteur.",
      needs_admin: "Un administrateur de l’organisation doit autoriser cette action.",
      generic: "Cette capacité n’est pas disponible ici.",
    },
    capabilityHintDismiss: "Non merci",
    studioArchitecturePlanApproveError: "Échec de l’approbation du plan d’architecture",
    studioArchitecturePlanApply: "Mettre en œuvre",
    studioArchitecturePlanApplied: "Plan d’architecture mis en œuvre",
    studioArchitecturePlanApplyError: "Échec de la mise en œuvre du plan d’architecture",
    studioArchitectureFollowUps: "Sous-plans Agent Spec",
    studioArchitectureOpenFollowUp: "Ouvrir le fil Studio",
    studioArchitecturePlanOps: "{{count}} opération(s)",
    studioMentionHint: "Agent, Application ou autre fil",
    studioAttentionNeedsApproval: "Approbation requise",
    studioAttentionBlocked: "Bloqué",
    studioAttentionRunning: "En cours",
    studioMessagePlaceholder: "Décrivez ce que vous voulez changer…",
    studioSend: "Envoyer",
    studioStop: "Arrêter",
    studioSending: "Préparation d’une proposition…",
    studioActivityTool: "Studio prépare une proposition…",
    studioRuntimeToolResult: "Résultat de l’outil {{name}}",
    studioWorkflowExecution: "Exécution du Workflow {{name}}",
    studioStaffDispatchSent: "Message à {{name}}",
    studioStaffDispatchReceived: "Message du Chef d'orchestre",
    studioStaffDispatchReplied: "Réponse de {{name}}",
    studioStaffDispatchFallback: "l’Agent",
    studioShowStructuredResult: "Afficher le résultat structuré",
    studioViewExecution: "Voir l’exécution, les logs et la trace",
    studioActivityCheck: "Studio vérifie le brouillon…",
    studioResponseSlow:
      "Le modèle met du temps à répondre. On attend la suite.",
    studioResponseTimeout:
      "La réponse Studio prend trop de temps. Le fil a été rechargé ; vous pouvez réessayer.",
    studioAttach: "Joindre un document",
    studioAttachmentReady: "{{name}} prêt",
    studioAttachmentRejected: "{{name}} refusé",
    studioDraftValid: "Brouillon prêt à publier",
    studioDraftInvalid: "{{count}} problème(s)",
    studioPreparePlan: "Préparer le plan",
    studioPreparingPlan: "Préparation…",
    studioPlanPrepared: "Plan prêt.",
    studioNewRevision: "Nouveau brouillon",
    studioStreamingConnected: "Synchronisé",
    studioStreamingDisconnected: "Reconnexion…",
    studioSharedHint: "Ce fil est partagé avec l’équipe.",
    studioNoAgent: "Sélectionnez un Agent pour ouvrir Studio.",
    studioWritePermissionRequired:
      "La permission write:recipes est requise pour utiliser Studio.",
    studioError: "Studio est momentanément indisponible.",
    studioInsufficientCredits:
      "Les crédits IA de l’organisation sont épuisés. Rechargez le portefeuille avant de réessayer.",
    studioRevisionConflict:
      "Le draft a changé pendant ce tour. Le fil a été rechargé et votre message a été restauré ; vous pouvez le renvoyer.",
    studioNoActiveDraft:
      "Ce brouillon n’est plus modifiable. Cliquez « Nouveau brouillon », puis décrivez le changement dans le fil.",
    studioRevisionStatus: {
      none: "Aucune révision",
      draft: "Draft",
      sealed: "Révision scellée",
      planned: "Révision planifiée",
      terminal: "Révision terminée",
    },
    provideRuntimeBindingTitle: "Variable ou secret requis",
    provideRuntimeBindingBody: "La valeur se saisit dans la feuille Variables de l’Agent. Elle ne passe ni par le chat, ni par l’agent.",
    provideRuntimeBindingAlias: "Alias",
    provideRuntimeBindingClassification: "Classification",
    provideRuntimeBindingName: "Nom",
    provideRuntimeBindingWorkflow: "Workflow",
    provideRuntimeBindingJustification: "Pourquoi",
    provideRuntimeBindingOpen: "Ouvrir la feuille Variables",
    studioAction: {
      prepare_plan: "Publier le brouillon",
      approve: "Examiner l’approbation",
      approve_architecture: "Approuver le plan d’architecture",
      connect_integration: "Connecter",
      confirm_integration: "Confirmer l’intégration",
      choose_provider: "Choisir un fournisseur",
      blocked: "Capacité bloquée",
      apply: "Examiner l’application",
      verify: "Examiner la vérification",
      preview: "Ouvrir la preview",
      test: "Tester la ressource",
      create_sandbox_agent: "Créer un Agent sandbox et y tester ce draft",
      new_revision: "Nouveau brouillon",
      provide_runtime_binding: "Renseigner la variable",
    },
  },
  en: {
    eyebrow: "Agent Studio",
    title: "Agent Spec",
    calistoNavigation: "Calisto",
    description:
      "Control this Agent desired state with an immutable plan and environment-appropriate governance.",
    selectContextTitle: "Selection required",
    selectOrganization: "Select an organization to load the Agent Spec.",
    selectAgent: "Select an Agent to load its Agent Spec.",
    loading: "Loading Agent Spec…",
    refresh: "Refresh",
    retry: "Try again",
    errorTitle: "Agent Spec unavailable",
    missingTitle: "No Agent Spec",
    missingDescription:
      "Initialize an empty draft. This action creates no runtime resource.",
    initAction: "Initialize Agent Spec",
    initPending: "Initializing…",
    overviewTitle: "This Agent",
    overviewDescription:
      "What is published: Workflows and MiniApps. Open an item to see its detail.",
    overviewEmptyWorkflows: "No Workflow.",
    overviewEmptyMiniapps: "No MiniApp.",
    studioPublished: "Published",
    identityTitle: "Name in the spec",
    agentMenu: "Agent actions",
    renameAgent: "Rename",
    renameAgentTitle: "Rename Agent",
    renameAgentDescription: "This name appears in the Studio tree.",
    renameAgentNameLabel: "Name",
    renameAgentConfirm: "Save",
    renameAgentSuccess: "Agent renamed.",
    renameAgentError: "Unable to rename this Agent.",
    deleteAgent: "Delete",
    deleteAgentTitle: "Delete Agent “{{name}}”?",
    deleteAgentDescription:
      "Permanently removes this Agent, its Workflows, and its Studio threads. This cannot be undone.",
    deleteAgentConfirm: "Delete",
    deleteAgentSuccess: "Agent deleted.",
    deleteAgentError: "Unable to delete this Agent.",
    importExportAgent: "Import / Export",
    status: "Status",
    specHash: "Spec hash",
    contract: "Contract",
    lastUpdate: "Last refresh",
    warningCount: "{{count}} warning(s)",
    currentPlanTitle: "Current plan",
    currentPlanDescription:
      "The plan to handle now: progress, next action, then history of other plans.",
    currentPlanEmpty:
      "No plan selected. Prepare one from the Studio thread, or open a plan from history.",
    otherPlansTitle: "Other plans",
    otherPlansDescription:
      "History of plans prepared by MauriceCLI, MCP, or the OS. Click one to make it the current plan.",
    otherPlansEmpty: "No other plans — the current plan is the only one available.",
    persistedPlansTitle: "Persisted plans to review",
    persistedPlansDescription:
      "Plans prepared by MauriceCLI, MCP, or the OS. Load the exact detail before any human approval.",
    persistedPlansLoading: "Loading persisted plans…",
    persistedPlansError: "Could not load persisted plans.",
    persistedPlansEmpty: "No recently prepared, approved, or applied plan.",
    refreshPlans: "Refresh plans",
    planStatusPrepared: "Needs approval",
    planStatusApproved: "Approved",
    planStatusApplying: "Applying",
    planStatusApplied: "Applied",
    planStatusFailed: "Failed",
    planStatusExpired: "Expired",
    planStatusSuperseded: "Superseded",
    gitCommit: "Git commit",
    expiresAt: "Expiration",
    exactArtifactTitle: "Exact executable artifact",
    exactArtifactDescription:
      "This persisted artifact is what the approval authorizes and what apply will execute without recompiling.",
    railTitle: "Current plan",
    railDescription:
      "In development: prepare then ship from the Studio thread. Staging/production require human approval.",
    railHintPull: "Load the desired state first (Pull).",
    railHintPrepare:
      "Next: Prepare the plan from the current Studio thread (check + plan; in development apply may continue automatically).",
    railHintApprove:
      "Next: Approve the plan (human approval required in this environment).",
    railHintCloseout:
      "Next: Ship changes (apply → verify, with auto-repair if needed).",
    railHintApplyPersisted:
      "Next: Apply this persisted plan. “Ship changes” only works for the sealed Studio thread plan.",
    railHintSuperseded:
      "This plan was superseded or expired. A newer plan was selected, or prepare a new one from the Studio thread.",
    railHintVerify: "Next: Verify the runtime result.",
    railHintIdle: "No urgent action — this plan is already handled or out of window.",
    railHintSelectOrCalisto:
      "Open Calisto to prepare a plan from a Studio thread, or choose a plan from history.",
    closeoutRequiresSealedRevision:
      "Shipping requires a plan prepared from the Studio thread (sealed revision). For this plan, use “Apply plan”.",
    closeoutRequiresPlan:
      "No plan is linked to the Studio revision. Prepare the plan from the thread first.",
    stepPull: "Pull",
    stepPullDescription: "V2 desired state loaded from the canonical source.",
    stepCheck: "Check",
    stepCheckDescription: "Contracts, capabilities and references validated.",
    stepPlan: "Plan",
    stepPlanDescription:
      "Diff and preconditions compiled into an immutable artifact.",
    stepApproval: "Approval",
    stepApprovalDescription:
      "Automatic policy authorization or human approval, depending on the environment.",
    stepApply: "Apply",
    stepApplyDescription: "Idempotent application of the approved artifact.",
    stepVerification: "Verification",
    stepVerificationDescription:
      "Desired state, runtime and provenance compared.",
    stateReady: "Ready",
    stateWaiting: "Waiting",
    stateRunning: "Running",
    stateComplete: "Complete",
    stateFailed: "Failed",
    checkAction: "Check spec",
    checkPending: "Checking…",
    planAction: "Prepare for review",
    planPending: "Preparing…",
    approvalAction: "Approve plan",
    applyAction: "Apply plan",
    applyPending: "Applying…",
    verifyAction: "Verify result",
    verifyPending: "Verifying runtime…",
    closeoutAction: "Ship changes",
    closeoutPending: "Shipping…",
    closeoutDescription:
      "Applies the approved plan, verifies runtime, then auto-repairs on failure.",
    studioPrepareAutoAction: "Auto-preparing…",
    studioPrepareAutoPending: "Preparing and shipping…",
    studioPrepareAutoStarted: "Plan prepared — closeout running or finished.",
    studioCloseoutStayInChat:
      "Draft applied. To keep editing, start a new revision then describe the change.",
    studioNewRevisionReady:
      "New draft ready — describe the next change to Calisto.",
    studioNewRevisionHint:
      "Opens a new editable draft in this thread. Then describe the change in the field below.",
    studioContinueWithCalisto: "Continue in Studio",
    openInCalisto: "Open in Studio",
    studioViewAppliedPlan: "See what was published",
    closeoutStatusIdle: "No closeout in progress",
    closeoutStatusAwaitingApproval: "Waiting for approval after repair",
    closeoutStatusClosingOut: "Publishing",
    closeoutStatusSucceeded: "Published",
    closeoutStatusRepairing: "Automatic retry",
    closeoutStatusBlocked: "Publication interrupted",
    closeoutRepairCycles: "Automatic attempts: {{current}}/{{max}}",
    closeoutEvidence: "Technical detail: {{detail}}",
    closeoutTechnicalDetail: "Technical detail",
    closeoutBlockedOutOfScope:
      "Another change happened on this Agent at the same time. The Workflow is already available; the check could not finish. You do not need to rewrite anything.",
    closeoutBlockedHuman:
      "The automatic check could not finish. You do not need to rewrite anything.",
    studioPreparePlanPublish: "Publish draft",
    studioPrepareHintPublish:
      "Publishes immediately on this Agent. You can still change it afterwards.",
    studioPrepareHintReview:
      "Prepares a proposal. A human must approve it before publication.",
    studioComposerExampleAdd: "Add a test workflow that returns a note",
    studioComposerExampleAdditive: "Do not change anything existing: only add",
    studioOpenPublishedWorkflow: "Open {{name}}",
    studioJobStatusQueued: "StudioJob queued",
    studioJobStatusRunning: "StudioJob running",
    studioJobStatusSucceeded: "StudioJob succeeded",
    studioJobStatusBlocked: "StudioJob blocked",
    studioJobStatusCancelled: "StudioJob cancelled",
    studioJobGoalLabel: "Goal: {{title}}",
    checkRequired: "A valid check is required before preparing the plan.",
    approvalRequired:
      "This environment policy requires human approval before apply.",
    policyAuthorized: "Automatically authorized by server policy.",
    approvalDialogTitle: "Human approval",
    approvalDialogDescription:
      "Confirm the diff, risk, environment, commit, and hash. The server binds your identity to the exact plan.",
    approvalCommentLabel: "Optional comment",
    approvalCommentPlaceholder: "Audit context or note…",
    approvalTextLabel: "Approval text",
    approvalTextPlaceholder: "I approve plan {{hash}}",
    approvalHashHint: "Exact hash: {{hash}}",
    approvalCancel: "Cancel",
    approvalConfirm: "Record approval",
    approvalPending: "Recording…",
    approvalTextInvalid: "The text must contain the exact plan hash.",
    failureTitle: "Apply failed",
    failureRecovery:
      "Fix the cause, then create a new plan with maurice spec deploy.",
    currentRuntimePlan: "Current runtime state comes from plan {{planId}}.",
    planTitle: "Immutable plan",
    planDescription: "Plan {{id}} — expires {{expiresAt}}",
    noPlan: "Prepare a plan to display its diff, risk and tests.",
    diffTitle: "Semantic diff",
    diffEmpty: "No semantic change.",
    diffAdded: "{{count}} addition(s)",
    diffModified: "{{count}} change(s)",
    diffRemoved: "{{count}} removal(s)",
    riskTitle: "Risk",
    riskLow: "Low",
    riskMedium: "Medium",
    riskHigh: "High",
    riskCritical: "Critical",
    blastRadiusTitle: "Blast radius",
    blastRadiusEmpty: "No runtime component touched.",
    testsTitle: "Test policy",
    testsMode: "Mode",
    testsEnvironment: "Environment",
    testsBlocking: "Blocking",
    testsPlan: "Test plan",
    present: "Present",
    absent: "Absent",
    yes: "Yes",
    no: "No",
    resourcesTitle: "Resource ownership",
    resourcesDescription:
      "Workflows and MiniApps included in this Agent Spec are managed and can never be changed directly.",
    workflowsTitle: "Workflows",
    miniappsTitle: "MiniApps",
    plansNavigation: "Plans",
    executionsNavigation: "Executions",
    agentView: "Agent view",
    navGroup: "Agent Spec",
    agentOverview: "Overview",
    workflowLabel: "Workflow",
    miniappLabel: "MiniApp",
    resourceSummary: "Summary",
    resourceGraph: "Graph",
    resourceApiCall: "API call",
    resourcePreview: "Preview",
    synchronousWorkflowCall: "Synchronous call",
    synchronousWorkflowCallDescription:
      "Waits for the Workflow to finish and returns its result directly.",
    asynchronousWorkflowCall: "Asynchronous call",
    asynchronousWorkflowCallDescription:
      "Starts the Workflow, immediately returns an execution ID, then lets the caller poll its status.",
    pollWorkflowExecution: "Poll the execution",
    graphSelectNode: "Select a node to inspect its configuration.",
    graphNodeDetails: "Node details",
    graphCloseNodeDetails: "Close node details",
    graphNodeId: "Identifier",
    graphNodeType: "Type",
    graphNodeConfiguration: "Configuration",
    selectResource: "Select a resource.",
    noResourceDescription: "No description.",
    runtimeResourcesErrorTitle: "Runtime resources unavailable",
    runtimeResourcesErrorDescription:
      "The displayed list may be incomplete. Runtime Workflows and MiniApps could not be loaded.",
    retryRuntimeResources: "Reload runtime resources",
    workflowActions: "Actions",
    miniappEvents: "Events",
    resourceOwnershipAndProvenance: "Ownership and provenance",
    managementMode: "Management mode",
    ownerRevision: "Owner revision",
    resourceVersion: "Resource version",
    ownerAgentSpec: "Owner Agent Spec",
    contentHash: "Content hash",
    inputSchema: "Input schema",
    outputSchema: "Output schema",
    workflowForms: "Forms",
    miniappRenderer: "Renderer",
    miniappComponent: "Component",
    stateSchema: "State schema",
    initialState: "Initial state",
    eventMappings: "Event mappings",
    copyApiRequest: "Copy API request",
    apiRequestCopied: "API request copied.",
    apiAvailableAfterApply:
      "This call will be available after the draft is applied.",
    createMiniappSession: "Create a MiniApp session",
    miniappEventLabel: "MiniApp event",
    manageApiKeys: "Manage API keys",
    resourceState: {
      deployed: "Deployed",
      modified: "Modified",
      new: "New",
      deleted: "Deleted",
      outsideSpec: "Outside Agent Spec",
    },
    previewSandboxDescription:
      "This temporary preview runs the draft on the current Agent (sandbox, development, or integration_test) without creating managed runtime resources.",
    previewRuntimeDescription:
      "This preview starts a runtime session of the deployed MiniApp on this Agent without changing the desired state.",
    previewRequiresSandboxTitle: "Preview unavailable on this Agent",
    previewRequiresSandboxBody:
      "The current Agent is in “{{profile}}” mode. Draft preview is limited to sandbox, development, and integration_test Agents. On staging/production, use the approval cycle, or switch to a development Agent.",
    previewRequiresSandboxError:
      "Draft preview is not available on this Agent (“{{profile}}” mode). It is allowed on sandbox, development, and integration_test.",
    previewUnknownProfile: "unknown",
    invalidPlanId:
      "Invalid plan id in the URL — parameter ignored. Select a plan from the list.",
    previewCreateSandboxAgent: "Create a sandbox Agent and test this draft there",
    previewSwitchAgentHint:
      "Or open the Agent switcher at the top left to switch to an existing sandbox Agent.",
    previewCreateSandboxTitle: "Create a sandbox Agent",
    previewCreateSandboxDescription:
      "A new Agent classified as sandbox will be created. You can initialize a draft there and run previews without touching this Agent.",
    previewCreateSandboxSeedDialogTitle:
      "Create a sandbox Agent and test this draft there",
    previewCreateSandboxSeedDescription:
      "Confirm to create the sandbox Agent, copy this draft, open chat, and continue the preview.",
    previewCreateSandboxSeedConfirm: "Confirm",
    previewCreateSandboxSeedTitle: "Sandbox draft — {{name}}",
    previewCreateSandboxSeedSuccess:
      "Sandbox Agent {{name}} ready. Draft copied — preview starting.",
    previewCreateSandboxContinueStarted: "Draft preview resumed on the sandbox.",
    previewCreateSandboxContinueFailed:
      "The draft was copied, but the preview could not start automatically.",
    previewCreateSandboxNameLabel: "Agent name",
    previewCreateSandboxNamePlaceholder: "Sandbox assistant",
    previewCreateSandboxConfirm: "Create and open",
    previewCreateSandboxSubmitting: "Creating…",
    previewCreateSandboxSuccess: "Sandbox Agent {{name}} created.",
    previewCreateSandboxFailed: "Unable to create the sandbox Agent.",
    previewCreateSandboxConflict:
      "An Agent with this name already exists. Choose a different name.",
    previewCreateSandboxNameRequired: "Agent name is required.",
    previewConfirmTitle: "Run this preview?",
    previewConfirmDescription:
      "This runs the draft in a temporary sandbox session without changing the applied runtime.",
    previewConfirmAction: "Run preview",
    runWorkflowPreview: "Run Workflow preview",
    runWorkflowPreviewBusy: "Workflow preview running",
    previewExecutionStarted: "Preview execution started",
    startMiniappPreview: "Open MiniApp preview",
    studioChatPreviewTitle: "Preview {{kind}} — {{id}}",
    studioChatPreviewClose: "Close preview",
    studioChatPreviewStarting: "Starting preview…",
    studioChatPreviewMissingDocument:
      "Document not found in the current draft.",
    studioChatPreviewOpenUIFallback:
      "OpenUI rendering incomplete — falling back to native rendering.",
    previewStateVersion: "State version {{version}}",
    executionsTitle: "Executions and observability",
    executionsDescription:
      "Workflow states, logs, traces, results, durations, usage, and costs.",
    executionsEmpty: "No execution for this Agent.",
    refreshExecutions: "Refresh executions",
    executionDetails: "Execution details",
    selectExecution: "Select an execution to inspect.",
    duration: "Duration",
    traceId: "Trace ID",
    llmCalls: "LLM calls",
    tokens: "Tokens",
    estimatedCost: "Estimated cost",
    executionLogs: "Logs",
    executionLogsEmpty: "No log.",
    executionResult: "Result",
    executionLoadError: "Unable to load this execution.",
    agentConfiguration: "Agent configuration",
    instructions: "Instructions",
    capabilities: "Capabilities",
    dependencies: "Dependencies",
    parameters: "Parameters",
    secretReferences: "Secret references",
    policyReferences: "Policies",
    governance: "Governance",
    exportBundle: "Export bundle",
    noWorkflows: "No Workflow declared.",
    noMiniapps: "No MiniApp declared.",
    managed: "Managed",
    unmanaged: "Unmanaged sandbox",
    managedDescription:
      "Read-only — every change goes through a new Agent Spec plan.",
    unmanagedDescription:
      "Direct mutation is allowed only in the explicitly unmanaged sandbox.",
    owner: "Owner",
    file: "File",
    version: "Version",
    diagnosticsTitle: "Diagnostics",
    noDiagnostics: "No diagnostic.",
    checkValid: "Agent Spec valid",
    checkInvalid: "Agent Spec invalid",
    verificationTitle: "Final verification",
    verificationVerified: "State verified",
    verificationDrifted: "Drift detected",
    desiredStateMatch: "Desired state matches",
    planApplied: "Plan applied",
    approvalApplied: "Approval consumed",
    provenance: "Provenance",
    studioPanelTitle: "Studio",
    studioPanelDescription:
      "This shared thread changes only the Agent Spec V2 draft.",
    studioNewThreadTitle: "New Studio thread",
    studioNewThreadDescription:
      "Choose the host Agent, an optional Application, and the environment.",
    studioNewThreadContextualDescription:
      "This thread uses the scope of the current node.",
    studioHostAgentLabel: "Host Agent",
    studioHostAgentPlaceholder: "Choose a host Agent",
    studioHostRequired: "Choose a host Agent",
    studioScopeApplicationLabel: "Application (scope)",
    studioScopeApplicationNone: "This Agent only",
    studioEnvironmentLabel: "Environment",
    studioHostLabel: "Host",
    studioScopeLabel: "Scope",
    studioScopeThisAgent: "this Agent",
    studioHostHint:
      "This thread is hosted by {{host}}. An architecture plan may touch other Agents.",
    studioContinueInStudio: "Continue in Studio",
    studioContinueInStudioGoal: "Observe then adjust the {{app}} surface",
    studioViewConversation: "Conversation",
    studioViewPlans: "Plans",
    studioViewTrajectory: "Trajectory",
    studioSearchThread: "Search this thread",
    studioSearchPlaceholder: "Messages, plans, tools…",
    studioForkThread: "Fork",
    studioForkPending: "Forking…",
    studioForkSuccess: "New thread created from this revision",
    studioChipPlanReady: "Plan ready to approve",
    studioChipApplying: "Applying…",
    studioChipApplied: "Applied",
    studioChipBlocked: "Needs a fix",
    studioBackToThread: "Back to thread",
    studioThreadMore: "More thread actions",
    studioThreadJournal: "Journal",
    studioNoPlansOnThread: "No plan on this thread.",
    studioEventThreadCreated: "Thread created",
    studioEventMessageCreated: "Message",
    studioEventTurnStarted: "Turn started",
    studioEventTurnCompleted: "Turn completed",
    studioEventDraftChecked: "Draft checked",
    studioEventRevisionUpdated: "Revision updated",
    studioEventToolStarted: "Tool started",
    studioEventToolCompleted: "Tool finished",
    studioNewCycle: "New cycle",
    studioReplayPreview: "Replay (preview)",
    studioTrajectoryEmpty: "No trajectory events for this thread.",
    studioTrajectoryKindSystem: "System",
    studioTrajectoryKindUser: "User",
    studioTrajectoryKindContext: "Context",
    studioTrajectoryKindTool: "Tool",
    studioTrajectoryKindSubtool: "Subtool",
    studioTrajectoryKindDecision: "Decision",
    studioInspectorSummary: "Summary",
    studioInspectorInput: "Input",
    studioInspectorResult: "Result",
    studioInspectorSchema: "Schema",
    studioInspectorDuration: "Duration",
    studioPlanKindArchitecture: "Architecture plan",
    studioPlanKindAgentSpec: "Agent Spec plan",
    studioPlanRisk: "Risk",
    studioPlanScope: "{{workflows}} Workflows · {{apps}} Applications",
    studioPlanEnvironment: "Environment",
    compositionTitle: "Effective composition",
    compositionDescription:
      "Read-only: resolved model, provenance, and runtime surface. The LLM catalog stays in Platform.",
    compositionNoAgent: "Select an Agent to view its composition.",
    compositionLlm: "Resolved model",
    compositionProvenance: "Provenance",
    compositionDoctor: "Doctor",
    compositionModules: "Modules",
    compositionSkills: "Session skills",
    compositionMcp: "MCP / sidecars",
    compositionGaps: "Gaps",
    compositionEmpty: "No composition available for this Agent.",
    studioNoThread: "No thread for this Agent.",
    studioNoThreadYet: "No thread yet.",
    studioThreadsTitle: "Studio threads",
    studioThreadsLoading: "Loading threads…",
    studioThreadsMore: "More",
    studioThreadsLess: "Less",
    studioSelectThreadHint:
      "Select a thread in the sidebar or create a new one.",
    studioCreateThread: "New thread",
    studioUntitledThread: "Thread",
    studioCreateThreadSuccess: "New thread created",
    studioChiefOfStaffWelcomeTitle: "Welcome",
    studioCreatingThread: "Creating…",
    studioFromGoalAction: "From a goal",
    studioFromGoalTitle: "Start from a goal",
    studioFromGoalDescription:
      "Creates a Studio thread with a closed_loop StudioJob bound to this goal.",
    studioFromGoalTitleLabel: "Goal title",
    studioFromGoalTitlePlaceholder: "e.g. Add a research workflow",
    studioFromGoalDescriptionLabel: "Description (optional)",
    studioFromGoalDescriptionPlaceholder:
      "Success criteria or context useful for Calisto…",
    studioFromGoalCancel: "Cancel",
    studioFromGoalConfirm: "Create StudioJob",
    studioFromGoalPending: "Creating…",
    studioFromGoalSuccess: "StudioJob created from goal",
    studioThreadLabel: "Shared thread",
    studioEmptyMessages: "Describe the changes to make to this Agent.",
    studioArchitectureEmptyTitle: "Organization graph (observe)",
    studioArchitectureEmptyLoading: "Loading graph…",
    studioArchitectureEmptyError: "Could not load the architecture graph.",
    studioArchitectureEmptyApps: "{{count}} Application(s)",
    studioArchitectureEmptyAgents: "{{count}} Agent(s)",
    studioArchitectureEmptyGaps: "{{count}} gap(s)",
    studioArchitecturePlanTitle: "Architecture plan",
    studioArchitecturePlanApprove: "Approve architecture plan",
    studioArchitecturePlanApproved: "Architecture plan approved",
    studioExecutionPlanTitle: "Execution plan",
    studioExecutionPlanGoal: "Goal",
    studioExecutionPlanPhases: "{{count}} phase(s)",
    studioExecutionPlanPhaseNodes: "{{count}} node(s)",
    studioExecutionPlanNodes: "{{count}} node(s) in total",
    studioExecutionPlanParallel: "{{count}} in parallel at most",
    studioExecutionPlanJobs: "{{count}} jobs at most",
    studioExecutionPlanDurationHM: "{{hours}} h {{minutes}} min",
    studioExecutionPlanDurationH: "{{hours}} h",
    studioExecutionPlanDurationM: "{{minutes}} min",
    studioExecutionPlanDurationS: "{{seconds}} s",
    studioExecutionPlanCost: "Max cost {{amount}}",
    studioExecutionPlanCostUnbounded: "Cost not bounded",
    studioExecutionPlanTimeout: "Max duration {{duration}}",
    studioExecutionPlanStatusValidated: "Proposed",
    studioExecutionPlanStatusRunning: "Launched",
    studioExecutionPlanStatusBlocked: "Blocked",
    studioExecutionPlanStatusCompleted: "Completed",
    studioExecutionPlanStatusFailed: "Failed",
    studioExecutionPlanStatusCancelled: "Cancelled",
    studioExecutionPlanLaunch: "Launch",
    studioExecutionPlanLaunching: "Launching…",
    studioExecutionPlanModify: "Modify",
    studioExecutionPlanModifyPrefix: "Change the plan: ",
    studioExecutionPlanFollowActivity: "Follow in Activity",
    studioExecutionPlanStale: "This plan changed since it was proposed. It has just been reloaded: review it before launching.",
    studioExecutionPlanLaunchError: "The plan could not be launched.",
    studioConnectIntegrationSuccess: "Connection ready.",
    studioConnectIntegrationError: "Could not start the connection.",
    studioConnectIntegrationRetryPrompt: "{{name}} is connected. Retry the action.",
    studioConnectIntegrationCancelled: "Connection cancelled.",
    integrationRiskTitle: "Confirm {{name}}",
    integrationRiskFallbackName: "Integration",
    integrationRiskFallbackAction: "action",
    integrationRiskCredits: "{{count}} credit(s)",
    integrationRiskApprove: "Authorize once",
    integrationRiskApproved: "Authorization saved. Retry the action.",
    integrationRiskApproveError: "Could not save the authorization.",
    integrationRiskApproveSuccess: "Authorization saved.",
    integrationRiskRetryPrompt:
      "Retry the same tool with the exact same business arguments. Authorization granted (authorization_id={{id}}). Pass authorization_id={{id}} as a sibling field of the tool call (not inside the business arguments).",
    connectIntegrationTitle: "Connect {{name}}",
    connectIntegrationBody: "Authorize your account so the Agent can use it in this thread.",
    capabilityChooseTitle: "Choose for {{name}}",
    capabilityChooseBody: "Several options are available. Pick the one to enable.",
    capabilityChooseFallbackName: "this capability",
    capabilityBlockedTitle: "{{name}} unavailable",
    capabilityBlockedFallbackName: "This capability",
    capabilityBlockedReason: {
      not_in_org_allowlist: "This connector is not allowed for your organization.",
      insufficient_credits: "Not enough credits to enable this connector.",
      needs_admin: "An organization admin must authorize this action.",
      generic: "This capability is not available here.",
    },
    capabilityHintDismiss: "No thanks",
    studioArchitecturePlanApproveError: "Failed to approve architecture plan",
    studioArchitecturePlanApply: "Apply",
    studioArchitecturePlanApplied: "Architecture plan applied",
    studioArchitecturePlanApplyError: "Failed to apply architecture plan",
    studioArchitectureFollowUps: "Agent Spec follow-up plans",
    studioArchitectureOpenFollowUp: "Open Studio thread",
    studioArchitecturePlanOps: "{{count}} operation(s)",
    studioMentionHint: "Agent, Application, or another thread",
    studioAttentionNeedsApproval: "Approval needed",
    studioAttentionBlocked: "Blocked",
    studioAttentionRunning: "Running",
    studioMessagePlaceholder: "Describe what you want to change…",
    studioSend: "Send",
    studioStop: "Stop",
    studioSending: "Preparing a proposal…",
    studioActivityTool: "Studio is preparing a proposal…",
    studioRuntimeToolResult: "{{name}} tool result",
    studioWorkflowExecution: "{{name}} Workflow execution",
    studioStaffDispatchSent: "Message to {{name}}",
    studioStaffDispatchReceived: "Message from the Chef d'orchestre",
    studioStaffDispatchReplied: "Reply from {{name}}",
    studioStaffDispatchFallback: "the Agent",
    studioShowStructuredResult: "Show structured result",
    studioViewExecution: "View execution, logs, and trace",
    studioActivityCheck: "Studio is checking the draft…",
    studioResponseSlow:
      "The model is taking a while to respond. Waiting for the rest.",
    studioResponseTimeout:
      "The Studio response is taking too long. The thread was refreshed; you can try again.",
    studioAttach: "Attach a document",
    studioAttachmentReady: "{{name}} ready",
    studioAttachmentRejected: "{{name}} rejected",
    studioDraftValid: "Draft ready to publish",
    studioDraftInvalid: "{{count}} issue(s)",
    studioPreparePlan: "Prepare the plan",
    studioPreparingPlan: "Preparing…",
    studioPlanPrepared: "Plan ready.",
    studioNewRevision: "New draft",
    studioStreamingConnected: "Synchronized",
    studioStreamingDisconnected: "Reconnecting…",
    studioSharedHint: "This thread is shared with the team.",
    studioNoAgent: "Select an Agent to open Studio.",
    studioWritePermissionRequired:
      "The write:recipes permission is required to use Studio.",
    studioError: "Studio is temporarily unavailable.",
    studioInsufficientCredits:
      "The organization’s AI credits are exhausted. Top up the wallet before trying again.",
    studioRevisionConflict:
      "The draft changed during this turn. The thread was refreshed and your message was restored; you can send it again.",
    studioNoActiveDraft:
      "This draft can no longer be edited. Click “New draft”, then describe the change in the thread.",
    studioRevisionStatus: {
      none: "No revision",
      draft: "Draft",
      sealed: "Sealed revision",
      planned: "Planned revision",
      terminal: "Terminal revision",
    },
    provideRuntimeBindingTitle: "Variable or secret required",
    provideRuntimeBindingBody: "Enter the value in the Agent variables sheet. It does not go through the chat or the agent.",
    provideRuntimeBindingAlias: "Alias",
    provideRuntimeBindingClassification: "Classification",
    provideRuntimeBindingName: "Name",
    provideRuntimeBindingWorkflow: "Workflow",
    provideRuntimeBindingJustification: "Why",
    provideRuntimeBindingOpen: "Open the variables sheet",
    studioAction: {
      prepare_plan: "Publish draft",
      approve: "Review approval",
      approve_architecture: "Approve architecture plan",
      connect_integration: "Connect",
      confirm_integration: "Confirm integration",
      choose_provider: "Choose a provider",
      blocked: "Capability blocked",
      apply: "Review apply",
      verify: "Review verification",
      preview: "Open preview",
      test: "Test resource",
      create_sandbox_agent: "Create a sandbox Agent and test this draft there",
      new_revision: "New draft",
      provide_runtime_binding: "Provide the variable",
    },
  },
  es: {
    eyebrow: "Agent Studio",
    title: "Agent Spec",
    calistoNavigation: "Calisto",
    description: "Controle el desired state de este Agente con un plan inmutable y la gobernanza adecuada al entorno.",
    selectContextTitle: "Selección requerida",
    selectOrganization: "Seleccione una organización para cargar el Agent Spec.",
    selectAgent: "Seleccione un Agente para cargar su Agent Spec.",
    loading: "Cargando Agent Spec…",
    refresh: "Actualizar",
    retry: "Reintentar",
    errorTitle: "Agent Spec no disponible",
    missingTitle: "Ningún Agent Spec",
    missingDescription: "Inicialice un draft vacío. Esta acción no crea ningún recurso runtime.",
    initAction: "Inicializar Agent Spec",
    initPending: "Inicializando…",
    overviewTitle: "Este Agent",
    overviewDescription:
      "Lo publicado: Workflows y MiniApps. Abra un elemento para ver el detalle.",
    overviewEmptyWorkflows: "Ningún Workflow.",
    overviewEmptyMiniapps: "Ninguna MiniApp.",
    studioPublished: "Publicado",
    identityTitle: "Título en la spec",
    agentMenu: "Acciones del Agent",
    renameAgent: "Renombrar",
    renameAgentTitle: "Renombrar el Agent",
    renameAgentDescription: "Este nombre aparece en el árbol Studio.",
    renameAgentNameLabel: "Nombre",
    renameAgentConfirm: "Guardar",
    renameAgentSuccess: "Agent renombrado.",
    renameAgentError: "No se pudo renombrar este Agent.",
    deleteAgent: "Eliminar",
    deleteAgentTitle: "¿Eliminar el Agent « {{name}} »?",
    deleteAgentDescription:
      "Elimina de forma definitiva este Agent, sus Workflows y sus hilos Studio. Esta acción es irreversible.",
    deleteAgentConfirm: "Eliminar",
    deleteAgentSuccess: "Agent eliminado.",
    deleteAgentError: "No se pudo eliminar este Agent.",
    importExportAgent: "Import / Export",
    status: "Estado",
    resourceVersion: "Versión del recurso",
    specHash: "Spec hash",
    contract: "Contrato",
    lastUpdate: "Última actualización",
    warningCount: "{{count}} advertencia(s)",
    currentPlanTitle: "Plan actual",
    currentPlanDescription: "El plan a tratar ahora: progreso, siguiente acción, luego el historial de otros planes.",
    currentPlanEmpty: "Ningún plan seleccionado. Prepárelo desde el hilo Studio, o abra uno del historial.",
    otherPlansTitle: "Otros planes",
    otherPlansDescription: "Historial de planes preparados por MauriceCLI, MCP o el OS. Un clic lo convierte en el plan actual.",
    otherPlansEmpty: "Ningún otro plan — el plan actual es el único disponible.",
    persistedPlansTitle: "Planes persistidos para revisar",
    persistedPlansDescription: "Planes preparados por MauriceCLI, MCP o el OS. Cargue el detalle exacto antes de cualquier aprobación humana.",
    persistedPlansLoading: "Cargando planes persistidos…",
    persistedPlansError: "No se pudieron cargar los planes persistidos.",
    persistedPlansEmpty: "No hay ningún plan preparado, aprobado o aplicado recientemente.",
    refreshPlans: "Actualizar planes",
    planStatusPrepared: "Pendiente de aprobación",
    planStatusApproved: "Aprobado",
    planStatusApplying: "Aplicando",
    planStatusApplied: "Aplicado",
    planStatusFailed: "Fallido",
    planStatusExpired: "Caducado",
    planStatusSuperseded: "Reemplazado",
    gitCommit: "Commit Git",
    expiresAt: "Caducidad",
    exactArtifactTitle: "Artefacto ejecutable exacto",
    exactArtifactDescription: "Este artefacto persistido es el que autoriza la aprobación y el que apply ejecutará sin recompilar.",
    railTitle: "Plan actual",
    railDescription: "En development: prepare y despliegue desde el hilo Studio. Staging/producción requieren aprobación humana.",
    railHintPull: "Cargue primero el desired state (Pull).",
    railHintPrepare: "Siguiente: Preparar el plan desde el hilo Studio actual (check + plan; en development la aplicación puede continuar automáticamente).",
    railHintApprove: "Siguiente: Aprobar el plan (aprobación humana requerida en este entorno).",
    railHintCloseout: "Siguiente: Poner en marcha (apply → verify, con reparación automática si hace falta).",
    railHintApplyPersisted: "Siguiente: Aplicar este plan persistido. « Poner en marcha » solo vale para el plan sellado del hilo Studio.",
    railHintSuperseded: "Este plan fue reemplazado o caducó. Se seleccionó un plan más reciente, o prepare uno nuevo desde el hilo Studio.",
    railHintVerify: "Siguiente: Verificar el resultado runtime.",
    railHintIdle: "Ninguna acción urgente — este plan ya está tratado o fuera de ventana.",
    railHintSelectOrCalisto: "Abra Calisto para preparar un plan desde un hilo Studio, o elija un plan del historial.",
    closeoutRequiresSealedRevision: "Poner en marcha exige un plan preparado desde el hilo Studio (revisión sellada). Para este plan, use « Aplicar el plan ».",
    closeoutRequiresPlan: "Ningún plan está vinculado a la revisión Studio. Prepare primero el plan desde el hilo.",
    stepPull: "Pull",
    stepPullDescription: "Desired state V2 cargado desde la fuente canónica.",
    stepCheck: "Check",
    stepCheckDescription: "Contratos, capacidades y referencias validados.",
    stepPlan: "Plan",
    stepPlanDescription: "Diff y precondiciones compilados en un artefacto inmutable.",
    stepApproval: "Aprobación",
    stepApprovalDescription: "Autorización automática por policy o aprobación humana según el entorno.",
    stepApply: "Apply",
    stepApplyDescription: "Aplicación idempotente del artefacto aprobado.",
    stepVerification: "Verificación",
    stepVerificationDescription: "Desired state, runtime y procedencia comparados.",
    stateReady: "Listo",
    stateWaiting: "En espera",
    stateRunning: "En curso",
    stateComplete: "Completado",
    stateFailed: "Fallido",
    checkAction: "Verificar la spec",
    checkPending: "Verificando…",
    planAction: "Preparar para validación",
    planPending: "Preparando…",
    approvalAction: "Aprobar el plan",
    applyAction: "Aplicar el plan",
    applyPending: "Aplicando…",
    verifyAction: "Verificar el resultado",
    verifyPending: "Verificando runtime…",
    closeoutAction: "Poner en marcha",
    closeoutPending: "Puesta en marcha…",
    closeoutDescription: "Aplica el plan aprobado, verifica el runtime y luego repara automáticamente en caso de fallo.",
    studioPrepareAutoAction: "Preparación automática…",
    studioPrepareAutoPending: "Preparación y puesta en marcha…",
    studioPrepareAutoStarted: "Plan preparado — closeout en curso o terminado.",
    studioCloseoutStayInChat: "Draft aplicado. Para seguir modificando, empiece una nueva revisión y describa el cambio.",
    studioNewRevisionReady: "Nuevo draft listo — describa el siguiente cambio a Calisto.",
    studioNewRevisionHint: "Abre un nuevo draft editable en este hilo. Luego describa el cambio en el campo de abajo.",
    studioContinueWithCalisto: "Continuar en Studio",
    openInCalisto: "Abrir en Studio",
    studioViewAppliedPlan: "Ver lo publicado",
    closeoutStatusIdle: "Ningún closeout en curso",
    closeoutStatusAwaitingApproval: "En espera de aprobación tras la reparación",
    closeoutStatusClosingOut: "Closeout en curso (apply → verify)",
    closeoutStatusSucceeded: "Publicación correcta",
    closeoutStatusRepairing: "Nuevo intento automático",
    closeoutStatusBlocked: "Publicación interrumpida",
    closeoutRepairCycles: "Intentos automáticos: {{current}}/{{max}}",
    closeoutEvidence: "Detalle técnico: {{detail}}",
    closeoutTechnicalDetail: "Detalle técnico",
    closeoutBlockedOutOfScope:
      "Otro cambio ha ocurrido a la vez en este Agent. El Workflow ya está disponible; el control no ha podido terminar. No tiene que reescribir nada.",
    closeoutBlockedHuman:
      "El control automático no ha podido terminar. No tiene que reescribir nada.",
    studioPreparePlanPublish: "Publicar el borrador",
    studioPrepareHintPublish:
      "Publica ahora mismo en este Agent. Podrá seguir modificándolo después.",
    studioPrepareHintReview:
      "Prepara una propuesta. Una persona deberá aprobarla antes de publicar.",
    studioComposerExampleAdd: "Añadir un workflow de prueba que devuelva una nota",
    studioComposerExampleAdditive: "No modificar nada existente: solo añadir",
    studioOpenPublishedWorkflow: "Abrir {{name}}",
    studioJobStatusQueued: "StudioJob en cola",
    studioJobStatusRunning: "StudioJob en curso",
    studioJobStatusSucceeded: "StudioJob correcto",
    studioJobStatusBlocked: "StudioJob bloqueado",
    studioJobStatusCancelled: "StudioJob cancelado",
    studioJobGoalLabel: "Goal: {{title}}",
    checkRequired: "Se requiere un check válido antes de preparar el plan.",
    approvalRequired: "La policy de este entorno exige una aprobación humana antes de apply.",
    policyAuthorized: "Autorizado automáticamente por la policy del servidor.",
    approvalDialogTitle: "Aprobación humana",
    approvalDialogDescription: "Confirme el diff, el riesgo, el entorno, el commit y el hash. El servidor vincula su identidad al plan exacto.",
    approvalCommentLabel: "Comentario opcional",
    approvalCommentPlaceholder: "Contexto o nota para la auditoría…",
    approvalTextLabel: "Texto de aprobación",
    approvalTextPlaceholder: "Apruebo el plan {{hash}}",
    approvalHashHint: "Hash exacto: {{hash}}",
    approvalCancel: "Cancelar",
    approvalConfirm: "Registrar la aprobación",
    approvalPending: "Registrando…",
    approvalTextInvalid: "El texto debe contener el hash exacto del plan.",
    failureTitle: "Fallo de aplicación",
    failureRecovery: "Cree un nuevo plan con maurice spec deploy después de corregir la causa.",
    currentRuntimePlan: "Estado runtime actual del plan {{planId}}.",
    planTitle: "Plan inmutable",
    planDescription: "Plan {{id}} — caducidad {{expiresAt}}",
    noPlan: "Prepare un plan para mostrar el diff, el riesgo y las pruebas.",
    diffTitle: "Diff semántico",
    diffEmpty: "Ningún cambio semántico.",
    diffAdded: "{{count}} alta(s)",
    diffModified: "{{count}} modificación(es)",
    diffRemoved: "{{count}} baja(s)",
    riskTitle: "Riesgo",
    riskLow: "Bajo",
    riskMedium: "Medio",
    riskHigh: "Alto",
    riskCritical: "Crítico",
    blastRadiusTitle: "Blast radius",
    blastRadiusEmpty: "Ningún componente runtime afectado.",
    testsTitle: "Política de pruebas",
    testsMode: "Modo",
    testsEnvironment: "Entorno",
    testsBlocking: "Bloqueante",
    testsPlan: "Test plan",
    present: "Presente",
    absent: "Ausente",
    yes: "Sí",
    no: "No",
    resourcesTitle: "Ownership de los recursos",
    resourcesDescription: "Los Workflows y MiniApps incluidos en este Agent Spec son managed y nunca se modifican directamente.",
    workflowsTitle: "Workflows",
    miniappsTitle: "MiniApps",
    plansNavigation: "Planes",
    executionsNavigation: "Ejecuciones",
    agentView: "Vista Agente",
    navGroup: "Agent Spec",
    agentOverview: "Vista general",
    workflowLabel: "Workflow",
    miniappLabel: "MiniApp",
    resourceSummary: "Resumen",
    resourceGraph: "Grafo",
    resourceApiCall: "Llamada API",
    resourcePreview: "Preview",
    synchronousWorkflowCall: "Llamada síncrona",
    synchronousWorkflowCallDescription: "Espera el final del Workflow y devuelve directamente su resultado.",
    asynchronousWorkflowCall: "Llamada asíncrona",
    asynchronousWorkflowCallDescription: "Inicia el Workflow, devuelve de inmediato un identificador de ejecución y permite seguir su estado.",
    pollWorkflowExecution: "Seguir la ejecución",
    graphSelectNode: "Seleccione un nodo para mostrar su configuración.",
    graphNodeDetails: "Detalles del nodo",
    graphCloseNodeDetails: "Cerrar los detalles del nodo",
    graphNodeId: "Identificador",
    graphNodeType: "Tipo",
    graphNodeConfiguration: "Configuración",
    selectResource: "Seleccione un recurso.",
    noResourceDescription: "Ninguna descripción.",
    runtimeResourcesErrorTitle: "Recursos runtime no disponibles",
    runtimeResourcesErrorDescription: "La lista mostrada puede estar incompleta. No se pudieron cargar los Workflows y MiniApps runtime.",
    retryRuntimeResources: "Recargar los recursos runtime",
    workflowActions: "Acciones",
    miniappEvents: "Eventos",
    resourceOwnershipAndProvenance: "Ownership y procedencia",
    managementMode: "Modo de gestión",
    ownerRevision: "Revisión propietaria",
    ownerAgentSpec: "Agent Spec propietario",
    contentHash: "Hash del contenido",
    inputSchema: "Esquema de entrada",
    outputSchema: "Esquema de salida",
    workflowForms: "Formularios",
    miniappRenderer: "Renderer",
    miniappComponent: "Componente",
    stateSchema: "Esquema de estado",
    initialState: "Estado inicial",
    eventMappings: "Mappings de eventos",
    copyApiRequest: "Copiar la solicitud API",
    apiRequestCopied: "Solicitud API copiada.",
    apiAvailableAfterApply: "Esta llamada estará disponible tras aplicar el draft.",
    createMiniappSession: "Crear una sesión MiniApp",
    miniappEventLabel: "Evento MiniApp",
    manageApiKeys: "Gestionar las claves API",
    resourceState: {
      deployed: "Desplegado",
      modified: "Modificado",
      new: "Nuevo",
      deleted: "Eliminado",
      outsideSpec: "Fuera del Agent Spec",
    },
    previewSandboxDescription: "Esta preview temporal ejecuta el draft en el Agente actual (sandbox, development o integration_test) sin crear un recurso runtime managed.",
    previewRuntimeDescription: "Esta preview inicia una sesión runtime de la MiniApp desplegada en este Agente, sin modificar el desired state.",
    previewRequiresSandboxTitle: "Preview no disponible en este Agente",
    previewRequiresSandboxBody: "El Agente actual está en modo « {{profile}} ». La preview del draft está limitada a sandbox, development e integration_test. En staging/producción use el ciclo de aprobación, o cambie a un Agente de desarrollo.",
    previewRequiresSandboxError: "La preview del draft no está disponible en este Agente (modo « {{profile}} »). Está permitida en sandbox, development e integration_test.",
    previewUnknownProfile: "desconocido",
    invalidPlanId: "Identificador de plan inválido en la URL — parámetro ignorado. Seleccione un plan de la lista.",
    previewCreateSandboxAgent: "Crear un Agente sandbox y probar este draft allí",
    previewSwitchAgentHint: "O abra el selector de Agente arriba a la izquierda para cambiar a un Agente sandbox existente.",
    previewCreateSandboxTitle: "Crear un Agente sandbox",
    previewCreateSandboxDescription: "Se creará un Agente clasificado como sandbox. Podrá inicializar un draft allí y lanzar previews sin tocar este Agente.",
    previewCreateSandboxSeedDialogTitle: "Crear un Agente sandbox y probar este draft allí",
    previewCreateSandboxSeedDescription: "Confirme para crear el Agente sandbox, copiar este draft, abrir el chat y continuar la preview.",
    previewCreateSandboxSeedConfirm: "Confirmar",
    previewCreateSandboxSeedTitle: "Draft sandbox — {{name}}",
    previewCreateSandboxSeedSuccess: "Agente sandbox {{name}} listo. Draft copiado — preview en curso.",
    previewCreateSandboxContinueStarted: "Preview del draft reanudada en el sandbox.",
    previewCreateSandboxContinueFailed: "El draft se copió, pero la preview no pudo iniciarse automáticamente.",
    previewCreateSandboxNameLabel: "Nombre del Agente",
    previewCreateSandboxNamePlaceholder: "Asistente sandbox",
    previewCreateSandboxConfirm: "Crear y abrir",
    previewCreateSandboxSubmitting: "Creando…",
    previewCreateSandboxSuccess: "Agente sandbox {{name}} creado.",
    previewCreateSandboxFailed: "No se pudo crear el Agente sandbox.",
    previewCreateSandboxConflict: "Ya existe un Agente con ese nombre. Elija otro nombre.",
    previewCreateSandboxNameRequired: "El nombre del Agente es obligatorio.",
    previewConfirmTitle: "¿Ejecutar esta preview?",
    previewConfirmDescription: "Esta acción ejecuta el draft en una sesión sandbox temporal sin modificar el runtime aplicado.",
    previewConfirmAction: "Ejecutar la preview",
    runWorkflowPreview: "Ejecutar la preview Workflow",
    runWorkflowPreviewBusy: "Preview Workflow en curso",
    previewExecutionStarted: "Ejecución de preview iniciada",
    startMiniappPreview: "Abrir la preview MiniApp",
    studioChatPreviewTitle: "Preview {{kind}} — {{id}}",
    studioChatPreviewClose: "Cerrar la preview",
    studioChatPreviewStarting: "Iniciando la preview…",
    studioChatPreviewMissingDocument: "Documento no encontrado en el draft actual.",
    studioChatPreviewOpenUIFallback: "Renderizado OpenUI incompleto — se usa el renderizado nativo.",
    previewStateVersion: "Estado versión {{version}}",
    executionsTitle: "Ejecuciones y observabilidad",
    executionsDescription: "Estados, logs, trazas, resultados, duraciones, usos y costes de los Workflows.",
    executionsEmpty: "Ninguna ejecución para este Agente.",
    refreshExecutions: "Actualizar las ejecuciones",
    executionDetails: "Detalles de la ejecución",
    selectExecution: "Seleccione una ejecución para examinar.",
    duration: "Duración",
    traceId: "Trace ID",
    llmCalls: "Llamadas LLM",
    tokens: "Tokens",
    estimatedCost: "Coste estimado",
    executionLogs: "Logs",
    executionLogsEmpty: "Ningún log.",
    executionResult: "Resultado",
    executionLoadError: "No se pudo cargar esta ejecución.",
    agentConfiguration: "Configuración del Agente",
    instructions: "Instrucciones",
    capabilities: "Capabilities",
    dependencies: "Dependencies",
    parameters: "Parámetros",
    secretReferences: "Referencias de secretos",
    policyReferences: "Policies",
    governance: "Gobernanza",
    exportBundle: "Exportar el bundle",
    noWorkflows: "Ningún Workflow declarado.",
    noMiniapps: "Ninguna MiniApp declarada.",
    managed: "Managed",
    unmanaged: "Sandbox unmanaged",
    managedDescription: "Solo lectura — cualquier modificación pasa por un nuevo plan Agent Spec.",
    unmanagedDescription: "Mutación directa autorizada solo en el sandbox explícitamente unmanaged.",
    owner: "Owner",
    file: "Archivo",
    version: "Versión",
    diagnosticsTitle: "Diagnósticos",
    noDiagnostics: "Ningún diagnóstico.",
    checkValid: "Agent Spec válido",
    checkInvalid: "Agent Spec inválido",
    verificationTitle: "Verificación final",
    verificationVerified: "Estado verificado",
    verificationDrifted: "Drift detectado",
    desiredStateMatch: "Desired state conforme",
    planApplied: "Plan aplicado",
    approvalApplied: "Aprobación consumida",
    provenance: "Procedencia",
    studioPanelTitle: "Studio",
    studioPanelDescription: "Este hilo compartido modifica únicamente el draft Agent Spec V2.",
    studioNewThreadTitle: "Nuevo hilo Studio",
    studioNewThreadDescription:
      "Elija el Agente anfitrión, una Application opcional y el entorno.",
    studioNewThreadContextualDescription:
      "Este hilo usa el alcance de este nodo.",
    studioHostAgentLabel: "Agente anfitrión",
    studioHostAgentPlaceholder: "Elegir un Agente anfitrión",
    studioHostRequired: "Elegir un Agente anfitrión",
    studioScopeApplicationLabel: "Application (alcance)",
    studioScopeApplicationNone: "Solo este Agente",
    studioEnvironmentLabel: "Entorno",
    studioHostLabel: "Anfitrión",
    studioScopeLabel: "Alcance",
    studioScopeThisAgent: "este Agente",
    studioHostHint:
      "Este hilo lo aloja {{host}}. Un plan de arquitectura puede tocar otros Agentes.",
    studioContinueInStudio: "Continuar en Studio",
    studioContinueInStudioGoal: "Observar y ajustar la superficie de {{app}}",
    studioViewConversation: "Conversación",
    studioViewPlans: "Planes",
    studioViewTrajectory: "Trayectoria",
    studioSearchThread: "Buscar en este hilo",
    studioSearchPlaceholder: "Mensajes, planes, herramientas…",
    studioForkThread: "Bifurcar",
    studioForkPending: "Bifurcando…",
    studioForkSuccess: "Nuevo hilo creado desde esta revisión",
    studioChipPlanReady: "Plan por aprobar",
    studioChipApplying: "Aplicando…",
    studioChipApplied: "Aplicado",
    studioChipBlocked: "A corregir",
    studioBackToThread: "Volver al hilo",
    studioThreadMore: "Más acciones del hilo",
    studioThreadJournal: "Diario",
    studioNoPlansOnThread: "Ningún plan en este hilo.",
    studioEventThreadCreated: "Hilo creado",
    studioEventMessageCreated: "Mensaje",
    studioEventTurnStarted: "Turno iniciado",
    studioEventTurnCompleted: "Turno terminado",
    studioEventDraftChecked: "Borrador verificado",
    studioEventRevisionUpdated: "Revisión actualizada",
    studioEventToolStarted: "Herramienta iniciada",
    studioEventToolCompleted: "Herramienta terminada",
    studioNewCycle: "Nuevo ciclo",
    studioReplayPreview: "Reproducir (preview)",
    studioTrajectoryEmpty: "Ningún evento de trayectoria para este hilo.",
    studioTrajectoryKindSystem: "Sistema",
    studioTrajectoryKindUser: "Usuario",
    studioTrajectoryKindContext: "Contexto",
    studioTrajectoryKindTool: "Herramienta",
    studioTrajectoryKindSubtool: "Subherramienta",
    studioTrajectoryKindDecision: "Decisión",
    studioInspectorSummary: "Resumen",
    studioInspectorInput: "Entrada",
    studioInspectorResult: "Resultado",
    studioInspectorSchema: "Esquema",
    studioInspectorDuration: "Duración",
    studioPlanKindArchitecture: "Plan de arquitectura",
    studioPlanKindAgentSpec: "Plan Agent Spec",
    studioPlanRisk: "Riesgo",
    studioPlanScope: "{{workflows}} Workflows · {{apps}} Applications",
    studioPlanEnvironment: "Entorno",
    compositionTitle: "Composición efectiva",
    compositionDescription:
      "Solo lectura: modelo resuelto, procedencia y superficie runtime. El catálogo LLM permanece en Plataforma.",
    compositionNoAgent: "Seleccione un Agente para ver su composición.",
    compositionLlm: "Modelo resuelto",
    compositionProvenance: "Procedencia",
    compositionDoctor: "Doctor",
    compositionModules: "Módulos",
    compositionSkills: "Skills de sesión",
    compositionMcp: "MCP / sidecars",
    compositionGaps: "Desviaciones",
    compositionEmpty: "Ninguna composición disponible para este Agente.",
    studioNoThread: "Ningún hilo para este Agente.",
    studioNoThreadYet: "Ningún hilo por el momento.",
    studioThreadsTitle: "Hilos Studio",
    studioThreadsLoading: "Cargando hilos…",
    studioThreadsMore: "Más",
    studioThreadsLess: "Menos",
    studioSelectThreadHint: "Seleccione un hilo en la barra lateral o cree uno nuevo.",
    studioCreateThread: "Nuevo hilo",
    studioUntitledThread: "Hilo",
    studioCreateThreadSuccess: "Nuevo hilo creado",
    studioChiefOfStaffWelcomeTitle: "Bienvenida",
    studioCreatingThread: "Creando…",
    studioFromGoalAction: "Desde un goal",
    studioFromGoalTitle: "Iniciar desde un goal",
    studioFromGoalDescription: "Crea un hilo Studio con un StudioJob closed_loop vinculado a este goal.",
    studioFromGoalTitleLabel: "Título del goal",
    studioFromGoalTitlePlaceholder: "Ej. Añadir un workflow de vigilancia",
    studioFromGoalDescriptionLabel: "Descripción (opcional)",
    studioFromGoalDescriptionPlaceholder: "Criterios de éxito o contexto útil para Calisto…",
    studioFromGoalCancel: "Cancelar",
    studioFromGoalConfirm: "Crear el StudioJob",
    studioFromGoalPending: "Creando…",
    studioFromGoalSuccess: "StudioJob creado desde el goal",
    studioThreadLabel: "Hilo compartido",
    studioEmptyMessages: "Describa los cambios a aportar a este Agente.",
    studioArchitectureEmptyTitle: "Grafo de organización (observe)",
    studioArchitectureEmptyLoading: "Leyendo el grafo…",
    studioArchitectureEmptyError: "No se pudo cargar el grafo de arquitectura.",
    studioArchitectureEmptyApps: "{{count}} Application(s)",
    studioArchitectureEmptyAgents: "{{count}} Agente(s)",
    studioArchitectureEmptyGaps: "{{count}} desviación(es)",
    studioArchitecturePlanTitle: "Plan de arquitectura",
    studioArchitecturePlanApprove: "Aprobar el plan de arquitectura",
    studioArchitecturePlanApproved: "Plan de arquitectura aprobado",
    studioExecutionPlanTitle: "Plan de ejecución",
    studioExecutionPlanGoal: "Objetivo",
    studioExecutionPlanPhases: "{{count}} fase(s)",
    studioExecutionPlanPhaseNodes: "{{count}} nodo(s)",
    studioExecutionPlanNodes: "{{count}} nodo(s) en total",
    studioExecutionPlanParallel: "{{count}} en paralelo como máximo",
    studioExecutionPlanJobs: "{{count}} jobs como máximo",
    studioExecutionPlanDurationHM: "{{hours}} h {{minutes}} min",
    studioExecutionPlanDurationH: "{{hours}} h",
    studioExecutionPlanDurationM: "{{minutes}} min",
    studioExecutionPlanDurationS: "{{seconds}} s",
    studioExecutionPlanCost: "Coste máx. {{amount}}",
    studioExecutionPlanCostUnbounded: "Coste sin límite",
    studioExecutionPlanTimeout: "Duración máx. {{duration}}",
    studioExecutionPlanStatusValidated: "Propuesto",
    studioExecutionPlanStatusRunning: "Lanzado",
    studioExecutionPlanStatusBlocked: "Bloqueado",
    studioExecutionPlanStatusCompleted: "Completado",
    studioExecutionPlanStatusFailed: "Fallido",
    studioExecutionPlanStatusCancelled: "Cancelado",
    studioExecutionPlanLaunch: "Lanzar",
    studioExecutionPlanLaunching: "Lanzando…",
    studioExecutionPlanModify: "Modificar",
    studioExecutionPlanModifyPrefix: "Modifica el plan: ",
    studioExecutionPlanFollowActivity: "Seguir en Actividad",
    studioExecutionPlanStale: "Este plan cambió desde su propuesta. Acaba de recargarse: revísalo antes de lanzarlo.",
    studioExecutionPlanLaunchError: "No se pudo lanzar el plan.",
    studioConnectIntegrationSuccess: "Conexión lista.",
    studioConnectIntegrationError: "No se pudo iniciar la conexión.",
    studioConnectIntegrationRetryPrompt: "Cuenta {{name}} conectada. Reintenta la acción.",
    studioConnectIntegrationCancelled: "Conexión cancelada.",
    integrationRiskTitle: "Confirmar {{name}}",
    integrationRiskFallbackName: "Integración",
    integrationRiskFallbackAction: "acción",
    integrationRiskCredits: "{{count}} crédito(s)",
    integrationRiskApprove: "Autorizar una vez",
    integrationRiskApproved: "Autorización registrada. Relance la acción.",
    integrationRiskApproveError: "No se pudo registrar la autorización.",
    integrationRiskApproveSuccess: "Autorización registrada.",
    integrationRiskRetryPrompt:
      "Relanza el mismo tool con exactamente los mismos argumentos de negocio. Autorización concedida (authorization_id={{id}}). Pasa authorization_id={{id}} como campo hermano de la llamada de herramienta (no dentro de los argumentos de negocio).",
    connectIntegrationTitle: "Conectar {{name}}",
    connectIntegrationBody: "Autoriza tu cuenta para que el Agente pueda usarla en este hilo.",
    capabilityChooseTitle: "Elegir para {{name}}",
    capabilityChooseBody: "Hay varias opciones. Elige la que quieres conectar.",
    capabilityChooseFallbackName: "esta capacidad",
    capabilityBlockedTitle: "{{name}} no disponible",
    capabilityBlockedFallbackName: "Esta capacidad",
    capabilityBlockedReason: {
      not_in_org_allowlist: "Este conector no está autorizado para tu organización.",
      insufficient_credits: "Créditos insuficientes para activar este conector.",
      needs_admin: "Un administrador de la organización debe autorizar esta acción.",
      generic: "Esta capacidad no está disponible aquí.",
    },
    capabilityHintDismiss: "No, gracias",
    studioArchitecturePlanApproveError: "Fallo al aprobar el plan de arquitectura",
    studioArchitecturePlanApply: "Poner en marcha",
    studioArchitecturePlanApplied: "Plan de arquitectura puesto en marcha",
    studioArchitecturePlanApplyError: "Fallo al poner en marcha el plan de arquitectura",
    studioArchitectureFollowUps: "Subplanes Agent Spec",
    studioArchitectureOpenFollowUp: "Abrir el hilo Studio",
    studioArchitecturePlanOps: "{{count}} operación(es)",
    studioMentionHint: "Agente, Application u otro hilo",
    studioAttentionNeedsApproval: "Aprobación requerida",
    studioAttentionBlocked: "Bloqueado",
    studioAttentionRunning: "En curso",
    studioMessagePlaceholder: "Describa lo que quiere cambiar…",
    studioSend: "Enviar",
    studioStop: "Detener",
    studioSending: "Preparando una propuesta…",
    studioActivityTool: "Studio prepara una propuesta…",
    studioRuntimeToolResult: "Resultado de la herramienta {{name}}",
    studioWorkflowExecution: "Ejecución del Workflow {{name}}",
    studioStaffDispatchSent: "Mensaje a {{name}}",
    studioStaffDispatchReceived: "Mensaje del Chef d'orchestre",
    studioStaffDispatchReplied: "Respuesta de {{name}}",
    studioStaffDispatchFallback: "el Agente",
    studioShowStructuredResult: "Mostrar el resultado estructurado",
    studioViewExecution: "Ver la ejecución, los logs y la traza",
    studioActivityCheck: "Calisto verifica el draft…",
    studioResponseSlow:
      "El modelo tarda en responder. Seguimos esperando.",
    studioResponseTimeout: "La respuesta Studio tarda demasiado. Se recargó el hilo; puede reintentar.",
    studioAttach: "Adjuntar un documento",
    studioAttachmentReady: "{{name}} listo",
    studioAttachmentRejected: "{{name}} rechazado",
    studioDraftValid: "Borrador listo para publicar",
    studioDraftInvalid: "{{count}} problema(s)",
    studioPreparePlan: "Preparar el plan",
    studioPreparingPlan: "Preparando…",
    studioPlanPrepared: "Plan listo.",
    studioNewRevision: "Nuevo borrador",
    studioStreamingConnected: "Sincronizado",
    studioStreamingDisconnected: "Reconectando…",
    studioSharedHint: "Este hilo se comparte con el equipo.",
    studioNoAgent: "Seleccione un Agente para abrir Studio.",
    studioWritePermissionRequired: "Se requiere el permiso write:recipes para usar Studio.",
    studioError: "Studio no está disponible temporalmente.",
    studioInsufficientCredits: "Los créditos de IA de la organización están agotados. Recargue la cartera antes de reintentar.",
    studioRevisionConflict: "El draft cambió durante este turno. Se recargó el hilo y se restauró su mensaje; puede reenviarlo.",
    studioNoActiveDraft: "Este borrador ya no se puede editar. Haga clic en « Nuevo borrador », luego describa el cambio en el hilo.",
    studioRevisionStatus: {
      none: "Ninguna revisión",
      draft: "Draft",
      sealed: "Revisión sellada",
      planned: "Revisión planificada",
      terminal: "Revisión terminada",
    },
    provideRuntimeBindingTitle: "Variable o secreto requerido",
    provideRuntimeBindingBody: "El valor se escribe en la hoja de variables del Agente. No pasa por el chat ni por el agente.",
    provideRuntimeBindingAlias: "Alias",
    provideRuntimeBindingClassification: "Clasificación",
    provideRuntimeBindingName: "Nombre",
    provideRuntimeBindingWorkflow: "Workflow",
    provideRuntimeBindingJustification: "Por qué",
    provideRuntimeBindingOpen: "Abrir la hoja de variables",
    studioAction: {
      prepare_plan: "Publicar el borrador",
      approve: "Revisar la aprobación",
      approve_architecture: "Aprobar el plan de arquitectura",
      connect_integration: "Conectar",
      confirm_integration: "Confirmar la integración",
      choose_provider: "Elegir un proveedor",
      blocked: "Capacidad bloqueada",
      apply: "Revisar la aplicación",
      verify: "Revisar la verificación",
      preview: "Abrir la preview",
      test: "Probar el recurso",
      create_sandbox_agent: "Crear un Agente sandbox y probar este draft allí",
      new_revision: "Nuevo borrador",
      provide_runtime_binding: "Indicar la variable",
    },
  },
} as const;
